// custom typefaces
import 'typeface-montserrat';
import 'typeface-merriweather';
// normalize CSS across browsers
import './src/normalize.css';
// custom CSS styles
import './src/style.css';

// Highlighting for code blocks
import 'prismjs/themes/prism.css';

import 'bootstrap/dist/css/bootstrap.min.css';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

import '../common/components/Accordion.css';

import React from 'react';
import { HeroUIProvider } from '@heroui/react';

export const wrapRootElement = ({ element }) => (
  <HeroUIProvider>{element}</HeroUIProvider>
);

// export const onServiceWorkerUpdateReady = () => {
//   const answer = window.confirm(
//     `This application has been updated. ` +
//       `Reload to display the latest version?`,
//   );

//   if (answer === true) window.location.reload();
// };

// export const onRouteUpdate = () => {
//   navigator.serviceWorker.register('/sw.js').then((reg) => {
//     reg.update();
//   });
// };
